import { getReflectProjection } from "@/lib/api/reflect";
import type { ReflectProjection } from "@/lib/api/projection-types";
import { createProjectionStore } from "./createProjectionStore";

export const useReflectProjectionStore = createProjectionStore<ReflectProjection, []>(
  getReflectProjection,
  []
);
